import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { RmaIconComponent } from '@rma/generic/ui/icon';
import { Attribution } from '../../domain/results';

@Component({
  selector: 'rma-result-attribution',
  imports: [RmaIconComponent, TranslocoModule],
  templateUrl: './attribution.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultAttributionComponent {
  @Input()
  attribution!: Attribution;

  @Input()
  rankingAttributions: string[] = [];

  @Input()
  name!: string;
}
